import { render, staticRenderFns } from "./ButtonFkDialog.vue?vue&type=template&id=c875d154&scoped=true"
import script from "./ButtonFkDialog.vue?vue&type=script&lang=js"
export * from "./ButtonFkDialog.vue?vue&type=script&lang=js"
import style0 from "./ButtonFkDialog.vue?vue&type=style&index=0&id=c875d154&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c875d154",
  null
  
)

export default component.exports